module.exports = __webpack_public_path__ + "img/about_us_2.261e6b6f.jpg";